import { render, staticRenderFns } from "./MatchOverview.vue?vue&type=template&id=a26d02e4&scoped=true&"
import script from "./MatchOverview.vue?vue&type=script&lang=js&"
export * from "./MatchOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26d02e4",
  null
  
)

export default component.exports